import React from 'react';
import Reveal from './Reveal';

const STEPS = [
  {
    title: 'Évaluez votre point de départ',
    text: 'Un bilan simple pour situer mémoire, focus et équilibre — la base de votre plan personnalisé.',
  },
  {
    title: 'Recevez un parcours adapté',
    text: 'Jeux, séances de pleine conscience et rythme quotidien sont assemblés selon vos besoins.',
  },
  {
    title: 'Entraînez-vous à votre cadence',
    text: 'Plus de 50 jeux disponibles en illimité pendant 3 mois, en sessions courtes ou plus longues.',
  },
  {
    title: 'Cultivez clarté et calme',
    text: 'La communauté et les rituels de pleine conscience vous aident à tenir le cap, jour après jour.',
  },
];

export default function Parcours() {
  return (
    <section id="parcours" className="py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-600">
                Le parcours
              </p>
              <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight">
                Quatre temps, sans détour.
              </h2>
            </div>
            <a
              href="/s"
              className="self-start lg:self-auto inline-flex px-6 py-3 rounded-md bg-pine-600 text-parchment text-sm font-bold hover:bg-pine-500 transition-colors"
            >
              Commencer mon bilan
            </a>
          </div>
        </Reveal>

        <ol className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, i) => (
            <Reveal key={step.title} delay={i * 90}>
              <li className="relative pl-0">
                <div className="font-display text-5xl font-semibold text-sand leading-none">
                  0{i + 1}
                </div>
                <h3 className="mt-4 font-display text-xl font-semibold leading-snug">
                  {step.title}
                </h3>
                <p className="mt-3 text-clay leading-relaxed">{step.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
